import EditIcon from "@material-ui/icons/Edit";
import Button from "@material-ui/core/Button";
import React, { Component } from "react";
export class EditIconButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onClick: props.onClick,
      caption: props.caption,
      hideToolTip: props.hideToolTip,
      pageId: props.pageId,
    };
  }

  onClick() {
    if (this.state.onClick) {
      this.state.onClick();
    }
  }
  render() {
    return (
      <span
        className="editDetails"
        onClick={this.onClick.bind(this)}
        style={{
          cursor: "pointer",
          fontSize: "x-larger",
          float: this.state.pageId !== "Event" ? "right" : "left",
          marginRight: "3px",
          // paddingTop: "5px",
          display: "flex",
        }}
      >
        {this.state.pageId !== "Event" ? (
          <Button
            variant="contained"
            // size="small"
            style={{
              background: "#d3d8de",
              color: "#353538",
              marginRight: "1rem",
              float: "right",
              textTransform: "capitalize",
              padding: "2px 10px",
            }}
            startIcon={<EditIcon />}
          >
            Edit
          </Button>
        ) : (
          <Button
            variant="contained"
            // size="small"
            style={{
              background: "#fff",
              color: "#000",
              fontWeight: "600",
              marginLeft: "0.6rem",
              float: "right",
              textTransform: "capitalize",
              padding: "2px 10px",
            }}
            startIcon={<EditIcon />}
          >
            Event Settings
          </Button>
        )}
      </span>
    );
  }
}
export default EditIconButton;
